import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function AboutPreview() {
  return <section className="bg-white py-24 lg:py-32" data-id="element-18" data-mp="17qwxyxdu6kej">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-19" data-mp="tutg83k5g4iy">
        <Reveal className="lg:col-span-5" data-id="element-20" data-mp="ytmi0yq2q73a">
          <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-21" data-mp="yuft2bw2fir8" />
          <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-22" data-mp="1mip9szef9gbi">
            Focused on people. Aligned with opportunity.
          </h2>
        </Reveal>
        <Reveal delay={0.05} className="lg:col-span-6 lg:col-start-7 lg:border-l lg:border-gold/40 lg:pl-12" data-id="element-23" data-mp="1crkx66c7y7ju">
          <p className="font-serif text-2xl leading-snug text-ink sm:text-[28px]" data-id="element-24" data-mp="1hpw68euowe10">
            Rising Talent Partners is an executive search and recruitment firm connecting
            organizations with experienced professionals.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-ink/75" data-id="element-25" data-mp="1f10ij04y8vmf">
            Our work centers on understanding each role in depth, identifying relevant candidates
            in the talent market, and facilitating professional introductions between employers
            and the people best suited to their needs.
          </p>
          <Link to="/about" className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold text-navy focus-visible:outline-none focus-visible:underline focus-visible:decoration-gold focus-visible:underline-offset-4" data-id="element-26" data-mp="1jzbr77jid032">
            <span className="border-b border-gold pb-0.5" data-id="element-27" data-mp="27ppbgbvupun3">Learn About Us</span>
            <ArrowRightIcon size={16} strokeWidth={1.5} className="transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="27nl9w0lfd7pz" />
          </Link>
        </Reveal>
      </div>
    </section>;
}